module.exports = __webpack_public_path__ + "static/img/7048_phase_function_Paper_PointsHejduk_Prediction.6049cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7048_phase_function_Paper_PointsHejduk_Prediction.png
// module id = C4VU
// module chunks = 0